/** 待支付状态（与后端 OrderInfoStatusEnum.CLASS_NAME_ZERO 一致） */
export const UNPAID_ORDER_STATUS = '0';

/**
 * 统一收银台支付成功后，本地订单是否已脱离「待支付」
 * @param {string|number|null|undefined} status
 */
export function isUnifiedOrderPaid(status) {
  if (status === null || status === undefined || status === '') {
    return false;
  }
  return String(status) !== UNPAID_ORDER_STATUS;
}

/**
 * 从统一收银台进入详情页后，轮询直到订单本地状态已支付或达到上限
 * @param {Object} options
 * @param {() => Promise<string|number|null|undefined>} options.fetchStatus 拉取最新主单/子单 status
 * @param {number} [options.maxAttempts=12]
 * @param {number} [options.intervalMs=1500]
 * @param {() => void} [options.onPaid] 检测到已支付
 * @param {() => void} [options.onTimeout] 轮询结束仍为待支付
 * @returns {() => void} 停止轮询
 */
export function startUnifiedPayStatusPoll({
  fetchStatus,
  maxAttempts = 12,
  intervalMs = 1500,
  onPaid,
  onTimeout,
}) {
  let stopped = false;
  let timer = null;
  let attempts = 0;

  const stop = () => {
    stopped = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const tick = async () => {
    if (stopped) {
      return;
    }
    attempts += 1;
    let status;
    try {
      status = await fetchStatus();
    } catch (e) {
      status = null;
    }
    if (isUnifiedOrderPaid(status)) {
      if (typeof onPaid === 'function') {
        onPaid(status);
      }
      stop();
      return;
    }
    if (attempts >= maxAttempts) {
      if (typeof onTimeout === 'function') {
        onTimeout();
      }
      stop();
      return;
    }
    timer = setTimeout(tick, intervalMs);
  };

  tick();
  return stop;
}
